import { useSettingsStore, type AudioSettings } from '../../store/settingsStore';
import { audio } from '../index';

type Slider = 'master' | 'music' | 'sfx';

const SLIDERS: { key: Slider; label: string }[] = [
  { key: 'master', label: 'Master' },
  { key: 'music', label: 'Music' },
  { key: 'sfx', label: 'Effects' },
];

/**
 * Master, Music and SFX sliders (0–100 with a % readout), Mute and Mute in background (spec §10).
 * Shared by the home footer and the HUD popover. Mute keeps the slider values; releasing the SFX
 * slider previews a click at the new level.
 */
export function AudioPanel() {
  const settings = useSettingsStore((s) => s.audio);
  const setAudio = useSettingsStore((s) => s.setAudio);
  const set = (patch: Partial<AudioSettings>) => setAudio(patch);
  return (
    <div className="audio-panel" role="group" aria-label="Sound">
      {SLIDERS.map(({ key, label }) => (
        <label key={key} className="audio-slider">
          <span>{label}</span>
          <input
            type="range"
            min={0}
            max={100}
            step={1}
            value={settings[key]}
            aria-valuetext={`${settings[key]}%`}
            onChange={(e) => set({ [key]: Number(e.target.value) })}
            onPointerUp={key === 'sfx' ? preview : undefined}
            onKeyUp={key === 'sfx' ? preview : undefined}
          />
          <output>{settings[key]}%</output>
        </label>
      ))}
      <label className="audio-check">
        <input
          type="checkbox"
          checked={settings.muted}
          onChange={(e) => set({ muted: e.target.checked })}
        />
        Mute
      </label>
      <label className="audio-check">
        <input
          type="checkbox"
          checked={settings.muteInBackground}
          onChange={(e) => set({ muteInBackground: e.target.checked })}
        />
        Mute in background
      </label>
    </div>
  );
}

/** The SFX slider was released: play a click at the new level. */
function preview() {
  audio.play('ui.click');
}
